module.exports = __webpack_public_path__ + "img/register.604a4c7a.svg";